<template>
  <div class="retry-or-edit-payment">
    <div class="payment-details">
      <div class="edit-payment" v-if="editing">
        <stripe-payment
          class="payment"
          ref="stripe"
          @got-source="handleGotSource"
          @payment-error="handlePaymentError"
          :options="stripeOptions"
          :existingSubscriptionId="invoice.subscription_id"
          :invoice="invoice"
        />
      </div>
      <div class="payment-method" v-else>
        Payment Method: **** **** **** {{ invoice.charge_attempt.last4 }}
        <a href="" @click.prevent="toggleEditing" class="edit">{{
          $t("message.edit")
        }}</a>
      </div>
    </div>
    <div class="feedback" v-if="success">
      Success! Your subscription to the {{ currentEdition.name }} is active.
    </div>
    <div class="feedback" v-if="error">
      {{ error }}
    </div>
    <div class="due" v-if="displayAmountDue">
      <strong> ${{ invoice.amount / 100 }} due today </strong>
    </div>
    <div class="buttons">
      <action-button
        @click="$emit('done')"
        v-if="success"
        class="primary-bg secondary-bg-hover"
      >
        Done
      </action-button>
      <action-button
        v-else
        @click.prevent="retryPayment"
        class="retry primary-bg secondary-bg-hover"
        :busy="retrying"
      >
        Retry Payment
      </action-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.retry-or-edit-payment {
  .feedback {
    margin-top: 1em;
    background: #cccccc75;
    padding: 0.75em;
    border-radius: 5px;
  }
  .buttons {
    margin-bottom: 1em;
    .retry {
      height: 3em;
    }
  }
  .payment-method {
    line-height: 2em;
    .edit {
      text-decoration: none;
      padding: 5px 18px;
      display: inline;
      width: fit-content;
      color: #333;
      background: #ccc;
      border-radius: 999px;
      margin-left: 8px;
      position: relative;
    }
  }
  .due {
    margin-top: 1em;
    font-weight: bold;
  }
}
</style>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ActionButton from "@/common/components/ActionButton";
import StripePayment from "@/signup/StripePayment";

export default {
  components: { StripePayment, ActionButton },
  props: {
    invoice: {
      required: true,
    },
    displayAmountDue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stripeOptions: null,
      editing: false,
      retrying: false,
      success: false,
      error: false,
    };
  },
  computed: {
    ...mapGetters(["currentEdition"]),
  },
  methods: {
    async retryOriginalPayment() {
      try {
        let response = await axios.post(
          `/api/billing/invoices/${this.invoice.id}/charge`
        );
        this.success = true;
      } catch (err) {
        this.handlePaymentError(err);
      }
      this.retrying = false;
    },
    retryPayment() {
      this.error = false;
      this.success = false;
      this.retrying = true;
      if (this.editing) {
        this.$refs.stripe.pay();
      } else {
        this.retryOriginalPayment();
      }
    },
    async toggleEditing() {
      if (this.editing) {
        this.editing = false;
        return;
      }
      try {
        let response = await axios.post("/payment/prepare_retry", {
          invoice_id: this.invoice.id,
        });
        this.stripeOptions = response.data;
        this.editing = true;
      } catch (err) {
        this.handlePaymentError(err);
      }
    },
    async handleGotSource(source) {
      try {
        await axios.post("/payment/retry", {
          source: source.id,
          subscription: this.invoice.subscription_id,
          invoice: this.invoice.id,
        });
        this.success = true;
      } catch (err) {
        this.handlePaymentError(err);
      }
      this.retrying = false;
    },
    handlePaymentError(messageOrError) {
      let message = "Try editing your payment method.";
      if (typeof messageOrError === "string") {
        if (messageOrError) {
          message = messageOrError;
        }
      } else if (messageOrError.response && messageOrError.response.data.error) {
        message = messageOrError.response.data.error.description;
      }
      let error = "Your payment couldn't be processed. " + message;
      this.error = error;
      this.retrying = false;
    },
  },
};
</script>
